export default __webpack_public_path__ + "static/media/Mobiles2.86da442f.png";